import PropTypes from "prop-types";
import React from "react";
import Str from "shared/components/Str";

import { SCREENS } from "apps/login_old/util/constants";

import "./PasswordSubmit.scss";

if (process.env.PLATFORM === "desktop") {
	require("./PasswordSubmit.desktop.scss");
} else {
	require("./PasswordSubmit.mobile.scss");
}

class PasswordSubmit extends React.Component {
	static propTypes = {
		changeScreen: PropTypes.func.isRequired,
	};

	_backToLogin = () => {
		this.props.changeScreen(SCREENS.LOGIN);
	};

	render() {
		return (
			<span className="login2017-form">
				<div className="login2017-fields">
					<Str className="login2017-fields-text">
						A password reset email is on its way. Check your Spam folder.
					</Str>
				</div>

				<div className="login2017-fields-illustration passwordsubmit-illustration" />

				<div className="login2017-actions login2017-footer">
					<button
						className="passwordsubmit-button login2017-actions-button"
						onClick={this._backToLogin}
					>
						Sign in
					</button>
				</div>
			</span>
		);
	}
}

export default PasswordSubmit;



// WEBPACK FOOTER //
// ./src/apps/login_old/components/screens/PasswordSubmit.jsx